<template>
    <div class="bg-color rounded-5 p-5">
        <div class="w-100 rounded-4">
            <div
                class="d-flex justify-content-between"
                style="background: rgb(241, 247, 255); border-radius: 27px 27px 0 0"
            >
                <div class="flex align-items-center list-page-header">
                    <h1 class="px-5 py-3 page-heading">Chatbot Builder</h1>
                </div>
            </div>
            <div class="w-100 bg-white" v-if="loading">
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>Loading chatbot configuration...</h4>
                </div>
            </div>
        </div>
        <Loading v-if="loading" />
    </div>
</template>

<script>
    import Loading from '@/components/general/loading/loading.vue';

    export default {
        name: 'ChatbotBuilderList',
        components: {
            Loading,
        },
        data() {
            return {
                loading: true,
            };
        },
        methods: {
            async checkAndRedirect() {
                // Always redirect to the single chatbot configuration page
                // The ChatbotBuilder component will handle loading existing config or creating new
                this.$router.replace({ name: 'ChatbotBuilder' });
            },
        },
        async created() {
            await this.checkAndRedirect();
        },
    };
</script>

<style scoped>
    .bg-color {
        background-color: rgba(255, 255, 255, 0.9);
    }

    .list-page-header {
        display: block;
        margin: 0;
        padding: 0;
        background: none;
    }
</style>
